import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './EditDepartmentDialog.css';

const EditDepartmentDialog = ({ department, faculty, isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    nameEn: '',
    faculty: '',
    faculty_ref: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (department && faculty && isOpen) {
      setFormData({
        name: department.name || '',
        nameEn: department.nameEn || '',
        faculty: faculty.name,
        faculty_ref: faculty._id
      });
      setError('');
    }
  }, [department, faculty, isOpen]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.put(`/departments/${department._id}`, formData);
      
      if (response.data.success) {
        onSave(response.data.data);
        onClose();
      } else {
        setError(response.data.message || 'Failed to update department');
      }
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Invalid data. Please check your input.');
      } else if (err.response?.status === 401) {
        setError('Unauthorized. Please log in again.');
      } else if (err.response?.status === 404) {
        setError('Department not found.');
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.');
      } else {
        setError('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  if (!isOpen || !department || !faculty) return null;

  return (
    <div className="dialog-overlay" onClick={handleClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>Edit Department</h2>
          <p className="faculty-info">Faculty: {faculty.name}</p>
          <button 
            className="close-button" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="dialog-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="name">Department Name (Bengali) *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter department name in Bengali"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="nameEn">Department Name (English) *</label>
            <input
              type="text"
              id="nameEn"
              name="nameEn"
              value={formData.nameEn}
              onChange={handleChange}
              required
              placeholder="Enter department name in English"
              disabled={loading}
            />
          </div>
          
          <div className="dialog-actions">
            <button 
              type="button" 
              className="cancel-button"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="save-button"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDepartmentDialog;
